module.exports = __webpack_public_path__ + "static/media/garuda-usdt.efe3f719.png";